<form [formGroup]="form" (submit)="$event.preventDefault()">
  <mat-card>
    <mat-card-title></mat-card-title>

    <mat-card-content>
      <div class="row">
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">
              {{displayNames["riptUrl"]}}
              <!-- @if (!riptUrl.disabled) {
                <span class="required"></span>
              } -->
            </label>
            <mat-form-field class="full-width">
              <input matInput formControlName="riptUrl">
              <mat-error *ngIf="getErrorMessage('riptUrl') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label  ">{{displayNames["likelyScenario"]}}</label>
            <mat-form-field class="full-width readonly">
              <textarea readonly matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
                formControlName="likelyScenario"></textarea>
              <mat-error *ngIf="getErrorMessage('likelyScenario') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label ">{{displayNames["criteriaDrivingScore"]}}</label>
            <mat-form-field class="full-width readonly">
              <input matInput formControlName="criteriaDrivingScore" readonly>
              <mat-error *ngIf="getErrorMessage('criteriaDrivingScore') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["likelyConsequence"]}}</label>
            <mat-form-field class="full-width readonly">
              <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
                formControlName="likelyConsequence" readonly></textarea>
              <mat-error *ngIf="getErrorMessage('likelyConsequence') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["abcPrioritization"]}}</label>
            <mat-form-field class="full-width readonly">
              <input matInput formControlName="abcPrioritization" readonly>
              <mat-error *ngIf="getErrorMessage('abcPrioritization') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["riskManRiskScore"]}}</label>
            <mat-form-field class="full-width readonly">
              <input matInput formControlName="riskManRiskScore" readonly>
              <mat-error *ngIf="getErrorMessage('riskManRiskScore') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["seriatimRank"]}}</label>
            <mat-form-field class="full-width readonly">
              <input matInput type="number" formControlName="seriatimRank" readonly>
              <mat-error *ngIf="getErrorMessage('seriatimRank') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["riskManCategory"]}}</label>
            <mat-form-field class="full-width readonly">
              <input matInput formControlName="riskManCategory" readonly>
              <mat-error *ngIf="getErrorMessage('riskManCategory') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["initialInvestment"]}}</label>
            <mat-form-field class="full-width readonly">
              <input matInput type="number" formControlName="initialInvestment" readonly>
              <mat-error *ngIf="getErrorMessage('initialInvestment') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["rorPercent"]}}</label>
            <mat-form-field class="full-width readonly">
              <input matInput type="number" formControlName="rorPercent" readonly>
              <mat-error *ngIf="getErrorMessage('ror') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["hseRiskEfficiency"]}}</label>
            <mat-form-field class="full-width readonly">
              <input matInput type="number" formControlName="hseRiskEfficiency" readonly>
              <mat-error *ngIf="getErrorMessage('hseRiskEfficiency') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["dpi"]}}</label>
            <mat-form-field class="full-width readonly">
              <input matInput type="number" formControlName="dpi" readonly>
              <mat-error *ngIf="getErrorMessage('dpi') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["needRiskAnalysis"]}}</label>
            <mat-slide-toggle formControlName="needRiskAnalysis" class="form-label"></mat-slide-toggle>
          </div>
        </div>



        <div class="col-sm-6">
          <div class="horizontal-form-field">
            <label class="form-label">{{displayNames["assetRisk"]}}</label>
            <mat-form-field class="full-width readonly">
              <input matInput formControlName="assetRisk" readonly>
              <mat-error *ngIf="getErrorMessage('assetRisk') as errorMessage">{{ errorMessage }}</mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <ng-container *ngIf="needRiskAnalysis.value">
    <mat-card>
      <mat-card-title class="section-title">Technical assessment description</mat-card-title>

      <mat-card-content formGroupName="technicalAssesment">
        <div class="row">
          <div class="col-md-6">
            <div class="horizontal-form-field">
              <label class="form-label">
                {{displayNames["technicalAssesment.operatingConditionDescriptionEN"]}}
                <span class="required"></span>
              </label>
              <mat-form-field class="full-width">
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
                  formControlName="operatingConditionDescriptionEN"></textarea>
                <mat-error
                  *ngIf="getErrorMessage('technicalAssesment.operatingConditionDescriptionEN') as errorMessage">
                  {{ errorMessage }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["technicalAssesment.operatingConditionDescriptionRU"]}}</label>
              <mat-form-field class="full-width">
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
                  formControlName="operatingConditionDescriptionRU"></textarea>
                <mat-error
                  *ngIf="getErrorMessage('technicalAssesment.operatingConditionDescriptionRU') as errorMessage">
                  {{ errorMessage }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["technicalAssesment.operatingConditionDescriptionKZ"]}}</label>
              <mat-form-field class="full-width">
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
                  formControlName="operatingConditionDescriptionKZ"></textarea>
                <mat-error
                  *ngIf="getErrorMessage('technicalAssesment.operatingConditionDescriptionKZ') as errorMessage">
                  {{ errorMessage }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="col-md-6">
            <div class="horizontal-form-field">
              <label class="form-label">
                {{displayNames["technicalAssesment.technicalAssesmentDescriptionEN"]}}
                <span class="required"></span>
              </label>
              <mat-form-field class="full-width">
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
                  formControlName="technicalAssesmentDescriptionEN"></textarea>
                <mat-error
                  *ngIf="getErrorMessage('technicalAssesment.technicalAssesmentDescriptionEN') as errorMessage">
                  {{ errorMessage }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["technicalAssesment.technicalAssesmentDescriptionRU"]}}</label>
              <mat-form-field class="full-width">
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
                  formControlName="technicalAssesmentDescriptionRU"></textarea>
                <mat-error
                  *ngIf="getErrorMessage('technicalAssesment.technicalAssesmentDescriptionRU') as errorMessage">
                  {{ errorMessage }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="horizontal-form-field">
              <label class="form-label">{{displayNames["technicalAssesment.technicalAssesmentDescriptionKZ"]}}</label>
              <mat-form-field class="full-width">
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
                  formControlName="technicalAssesmentDescriptionKZ"></textarea>
                <mat-error
                  *ngIf="getErrorMessage('technicalAssesment.technicalAssesmentDescriptionKZ') as errorMessage">
                  {{ errorMessage }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-title class="section-title">RoK Considerations</mat-card-title>

      <mat-card-content formGroupName="riskConsideration">
        <div class="horizontal-form-field">
          <label class="form-label">
            {{displayNames["riskConsideration.roKConsiderationsEN"]}}
            <span class="required"></span>
          </label>
          <mat-form-field class="full-width">
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
              formControlName="roKConsiderationsEN"></textarea>
            <mat-error *ngIf="getErrorMessage('riskConsideration.roKConsiderationsEN') as errorMessage">
              {{ errorMessage }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["riskConsideration.roKConsiderationsRU"]}}</label>
          <mat-form-field class="full-width">
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
              formControlName="roKConsiderationsRU"></textarea>
            <mat-error *ngIf="getErrorMessage('riskConsideration.roKConsiderationsRU') as errorMessage">
              {{ errorMessage }}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="horizontal-form-field">
          <label class="form-label">{{displayNames["riskConsideration.roKConsiderationsKZ"]}}</label>
          <mat-form-field class="full-width">
            <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="10"
              formControlName="roKConsiderationsKZ"></textarea>
            <mat-error *ngIf="getErrorMessage('riskConsideration.roKConsiderationsKZ') as errorMessage">
              {{ errorMessage }}
            </mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>
</form>
